const history = {
  title: "내 프로젝트",
  upgradeBtn: "업그레이드",
  subTitle: "파일은 24시간 후에 삭제될 것이니 다운로드 하는 것을 잊지 마세요.",
  MAgo: "{{num}} 분전에",
  HAgo: "{{num}} 시간전에",
  DAgo: "{{num}} day ago",
  justNow: "방금",
  originalFile: "원본 파일",
  selectAllBtn: "모두 선택",
  emptyTips: "프라젝트 없습니다. <1>편집하십시오.</1>",
  deleteTips: "삭제하시겠습니까?",
};

export default history;
